import UploadImage from "@components/UploadImage";
import { shotDemoList } from "@pages/videoCreating/BasicInfo/BasicInfoContent";
import { Popover } from "antd";
import { Trans } from "react-i18next";

export interface GuideProps {}

export const Guide = (_props: GuideProps) => {
  return (
    <Popover
      content={
        <div className="grid grid-cols-3 gap-y-[8px] gap-x-[4px] p-[8px] pb-[16px]">
          {shotDemoList.map((item) => (
            <div key={item.title} className="w-[120px] flex flex-col items-center">
              <UploadImage
                name={item.url}
                className="w-[120px] h-[120px] border border-solid border-kds-border-subtle"
              />
              <span className="font-semibold text-kds-fg mt-[6px] text-[13px] whitespace-nowrap">
                <Trans>{item.title}</Trans>
              </span>
            </div>
          ))}
        </div>
      }
      trigger="hover"
      placement="left"
    >
      <span className="kalo-text-linear-blue text-[14px] font-normal cursor-pointer">
        <Trans>Guide</Trans>
      </span>
    </Popover>
  );
};
